<template>
  <el-form ref="pileForm" :model="pileForm" :rules="pileRules" label-width="110px">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="设备型号" prop="deviceModel">
          <el-input
            v-if="!isDetail()"
            v-model="pileForm.deviceModel"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ pileForm.deviceModel || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="出厂编号" prop="factoryNo">
          <el-input
            v-if="!isDetail()"
            v-model="pileForm.factoryNo"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ pileForm.factoryNo || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="设备状态" prop="status">
          <el-select v-if="!isDetail()" v-model="pileForm.status" style="width: 100%">
            <el-option
              v-for="item in typeList"
              :key="item.type"
              :label="item.typeName"
              :value="item.type"
            ></el-option>
          </el-select>
          <span v-else>{{ typeObj[pileForm.status] }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="额定功率" prop="ratedPower">
          <el-input
            v-if="!isDetail()"
            v-model="pileForm.ratedPower"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ pileForm.ratedPower || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="输出电流范围" prop="outCurrentArea">
          <el-input
            v-if="!isDetail()"
            v-model="pileForm.outCurrentArea"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ pileForm.outCurrentArea || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="输入电压" prop="voltage">
          <el-input
            v-if="!isDetail()"
            v-model="pileForm.voltage"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ pileForm.voltage || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="工作环境温度" prop="temperature">
          <el-input
            v-if="!isDetail()"
            v-model="pileForm.temperature"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ pileForm.temperature || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="工作环境湿度" prop="humidity">
          <el-input
            v-if="!isDetail()"
            v-model="pileForm.humidity"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ pileForm.humidity || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="通讯功能" prop="communication">
          <el-input
            v-if="!isDetail()"
            v-model="pileForm.communication"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ pileForm.communication || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="技术标准" prop="technologyStandard">
          <el-input
            v-if="!isDetail()"
            v-model="pileForm.technologyStandard"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ pileForm.technologyStandard || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="接口标准" prop="interfaceStandard">
          <el-input
            v-if="!isDetail()"
            v-model="pileForm.interfaceStandard"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ pileForm.interfaceStandard || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Object
    }
  },
  data() {
    return {
      typeList: [
        { type: 0, typeName: '启用' },
        { type: 1, typeName: '停用' }
      ],
      typeObj: {
        0: '启用',
        1: '停用'
      },
      pileForm: {}
    };
  },
  inject: ['isDetail'],
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler: function (newVal) {
        this.pileForm = newVal;
      }
    },
    pileForm: {
      immediate: true,
      deep: true,
      handler: function (newVal) {
        this.$emit('change', newVal);
      }
    }
  },
  computed: {
    pileRules() {
      return {
        status: [{ required: !this.isDetail(), message: '请选择设备状态', trigger: 'change' }]
      };
    }
  },
  methods: {
    getNationNo() {
      // getNationNum().then(res => {
      //   if (!res.success) {
      //     return;
      //   }
      //   this.pileForm.mnNum = res.data
      // });
    },
    getData() {
      let data = {
        deviceModel: this.pileForm.deviceModel,
        factoryNo: this.pileForm.factoryNo,
        status: this.pileForm.status,
        ratedPower: this.pileForm.ratedPower,
        outputCurrent: this.pileForm.outCurrentArea,
        inputVoltage: this.pileForm.voltage,
        workAmbientTemp: this.pileForm.temperature,
        workAmbientHumidity: this.pileForm.humidity,
        communicatingFunction: this.pileForm.communication,
        technicalNorms: this.pileForm.technologyStandard,
        interfaceStandard: this.pileForm.interfaceStandard
      };
      return data;
    },
    setData(data) {
      const {
        deviceModel,
        factoryNo,
        status,
        ratedPower,
        outputCurrent,
        inputVoltage,
        workAmbientTemp,
        workAmbientHumidity,
        communicatingFunction,
        technicalNorms,
        interfaceStandard
      } = data;
      this.pileForm.deviceModel = deviceModel;
      this.pileForm.factoryNo = factoryNo;
      this.pileForm.status = status;
      this.pileForm.ratedPower = ratedPower;
      this.pileForm.outCurrentArea = outputCurrent;
      this.pileForm.voltage = inputVoltage;
      this.pileForm.temperature = workAmbientTemp;
      this.pileForm.humidity = workAmbientHumidity;
      this.pileForm.communication = communicatingFunction;
      this.pileForm.technologyStandard = technicalNorms;
      this.pileForm.interfaceStandard = interfaceStandard;
    },
    reset() {
      this.$refs.pileForm.resetFields();
    },
    validate() {
      let type;
      this.$refs.pileForm.validate(validated => {
        type = validated;
      });
      return type;
    }
  }
};
</script>
